export function extractStyleCacheId(string: string) {
  if (typeof string !== 'string') {
    return '';
  }

  const trimmedString = string.replace(/\s/g, '');

  if (trimmedString === '0') {
    return 'p0';
  }

  let styleCacheIdMatchArray = trimmedString.match(/p[0-9]+c?/ig);

  if (Array.isArray(styleCacheIdMatchArray) && styleCacheIdMatchArray.length > 0) {
    if (styleCacheIdMatchArray.length === 1) {
      return styleCacheIdMatchArray[0].toLowerCase();
    }

    styleCacheIdMatchArray = trimmedString.match(/i=p[0-9]+c?/ig);

    if (Array.isArray(styleCacheIdMatchArray) && styleCacheIdMatchArray.length === 1) {
      return styleCacheIdMatchArray[0].toLowerCase().slice(2);
    }
  }

  styleCacheIdMatchArray = trimmedString.match(/t[0-9]+c?/ig);

  if (Array.isArray(styleCacheIdMatchArray) && styleCacheIdMatchArray.length > 0) {
    if (styleCacheIdMatchArray.length === 1) {
      return styleCacheIdMatchArray[0].toLowerCase();
    }

    styleCacheIdMatchArray = trimmedString.match(/i=t[0-9]+c?/ig);

    if (Array.isArray(styleCacheIdMatchArray) && styleCacheIdMatchArray.length === 1) {
      return styleCacheIdMatchArray[0].toLowerCase().slice(2);
    }
  }

  styleCacheIdMatchArray = trimmedString.match(/id=0/ig);

  if (Array.isArray(styleCacheIdMatchArray) && styleCacheIdMatchArray.length === 1) {
    return 'p0';
  }

  styleCacheIdMatchArray = trimmedString.match(/i=0/ig);

  if (Array.isArray(styleCacheIdMatchArray) && styleCacheIdMatchArray.length === 1) {
    return 'p0';
  }

  return '';
}
